'use strict';
const _ = require('underscore'),
	cleanNonPrintable = require('@mindmup/js-utils/src/clean-non-printable'),
	MarkupBuilder = function (tag, namespace) {
		const self = this,
			children = [],
			appendPx = ['top', 'left', 'width', 'height', 'stroke-width'];
		let text,
			css = {},
			attributes = {},
			cdata;


		if (_.isEmpty(tag)) {
			throw 'trying to build an empty tag';
		}
		if (_.isEmpty(namespace)) {
			throw 'trying to build a tag with an empty namespace';
		}
		self.MindMupMarkupBuilder = true;
		self.text = function (newText) {
			text = newText;
			return self;
		};
		self.children = function () {
			return children.slice(0);
		};
		self.tagName = function () {
			return tag;
		};
		self.getAttributes = function () {
			return _.clone(attributes);
		};
		self.getCss = function () {
			return _.clone(css);
		};
		self.getText = function () {
			return '' + text;
		};
		self.cdata = function (newCdata) {
			cdata = newCdata;
			return self;
		};
		self.append = function (childMarkupBuilder) {
			if (!childMarkupBuilder || !childMarkupBuilder.MindMupMarkupBuilder) {
				throw 'trying to append something that is not a MarkupBuilder';
			}
			children.push(childMarkupBuilder);
			return self;
		};
		self.appendTo = function (parentMarkupBuilder) {
			if (!parentMarkupBuilder || !parentMarkupBuilder.MindMupMarkupBuilder) {
				throw 'trying to append to something that is not a MarkupBuilder';
			}
			parentMarkupBuilder.append(self);
			return self;
		};
		self.attr = function (newAttribs, value) {
			if (typeof newAttribs === 'object') {
				attributes = _.extend(attributes, newAttribs);
			} else {
				attributes[newAttribs] = value;
			}
			return self;
		};
		self.css = function (newCss, value) {
			if (typeof newCss === 'object') {
				css = _.extend (css, newCss);
			} else {
				css[newCss] = value;
			}
			return self;
		};
		self.serialize = function (buffer, parentNamespace) {
			let convertToString = false,
				cssBuffer = [];
			if (!buffer) {
				buffer = [];
				convertToString = true;
			}
			buffer.push('<');
			buffer.push(tag);
			if (parentNamespace !== namespace) {
				buffer.push(' xmlns="');
				buffer.push(namespace);
				buffer.push('"');
			}

			_.each(attributes, (v, k) => {
				if (v !== undefined && v !== '') {
					buffer.push(' ');
					buffer.push(k);
					buffer.push('="');
					buffer.push(String(v).replace(/"/g, '\''));
					buffer.push('"');
				}
			});
			if (!_.isEmpty(css)) {
				cssBuffer = [];
				_.each(css, (v, k) => {
					if (v !== undefined && v !== '') {
						cssBuffer.push(k);
						cssBuffer.push(':');
						cssBuffer.push(String(v).replace(/"/g, '\''));
						if (v !== 0 && _.contains(appendPx, k)) {
							cssBuffer.push('px');
						}
						cssBuffer.push(';');
					}
				});
				if (cssBuffer.length) {
					buffer.push(' style="');
					buffer.push(cssBuffer.join(''));
					buffer.push('"');
				}
			}
			if (text || cdata || !_.isEmpty(children)) {
				buffer.push('>');
				if (text) {
					buffer.push(cleanNonPrintable(_.escape(text)));
				}
				if (cdata) {
					buffer.push('<![CDATA[');
					buffer.push(cdata);
					buffer.push(']]>');
				}
				_.each(children, (childJq) => {
					childJq.serialize(buffer, namespace);
				});
				buffer.push('</');
				buffer.push(tag);
				buffer.push('>');
			} else {
				buffer.push('/>');
			}

			if (convertToString) {
				return buffer.join('');
			}
		};
	};

module.exports = {
	MarkupBuilder: MarkupBuilder,
	svgMarkupBuilder: function (tag) {
		return new MarkupBuilder(tag, 'http://www.w3.org/2000/svg');
	},
	domMarkupBuilder: function (tag) {
		return new MarkupBuilder(tag, 'http://www.w3.org/1999/xhtml');
	}
};

